/**
 * Constants to use in shadings.
 */
export const constants = /* wgsl */ `
const PI = ${Math.PI};
const PI2 = ${Math.PI * 2};
const RECIPROCAL_PI = ${1 / Math.PI};
const RECIPROCAL_PI2 = ${0.5 / Math.PI};
const EPSILON = 1e-6;`
